module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/pause-a5f6126837a3415cab9bb6f79866d493.svg";